import React from 'react';
import { Button, Checkbox, notification, Form, type FormProps, Input, Card, Select, DatePicker, InputNumber } from 'antd';
import { AdminService } from "./../../services/AdminService";
import { DatePickerProps } from 'antd/lib';
import { RangePickerProps } from 'antd/es/date-picker';


interface Props {
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();

    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
        })
    }, [props?.record])


    const onFinish: FormProps["onFinish"] = async (values) => {

        if (props?.record?.id) {
            var res = await AdminService.updateAdmin(values, props.record.id)
        } else {
            var res = await AdminService.saveAdmin(values)
            form.resetFields();
        }

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const onOk = (value: DatePickerProps['value'] | RangePickerProps['value']) => {
        console.log('onOk: ', value);
        form.setFieldValue('expired_date', value)
    };

    return (
        <Card
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    firstname: '',
                    lastname: '',
                    email: '',
                    password: ''
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Firstname"
                    name="firstname"
                    rules={[{ required: true, message: 'Please fill firstname' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Lastname"
                    name="lastname"
                    rules={[{ required: true, message: 'Please fill lastname' }]}
                >
                    <Input />
                </Form.Item>


                <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ type: 'email', required: true, message: 'Please fill email' }]}
                >
                    <Input autoComplete='off' autoCapitalize='off' />
                </Form.Item>

                {
                    !props?.record?.id ?
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={
                                [
                                    { required: true, message: "Please enter your password!" },
                                    { min: 6, message: "Password must be at least 6 characters!" }
                                ]
                            }
                        >
                            <Input.Password placeholder="Enter password" />
                        </Form.Item>
                        :
                        null
                }






                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
